// this should be the same as apps/bazaar/api/v2/constants.py#PAGE_SIZE

export const ITEMS_PER_PAGE = 40;

export const RECENT_REVIEW_DAYS = 90 * 24 * 60 * 60 * 1000; // 90 days
export const REVIEWS_PER_PAGE = 50;
export const TRANSACTIONS_PER_PAGE = 30;

// Experiment: slow scroll for this test user
export const SLOW_SCROLL_TEST_USER_ID = 629922;

export enum Viewer {
    ADMIN,
    SELLER,
    BUYER,
}
